import { Button } from '@change/ds-core-ui/next';

type Props = {
	id: string;
	email: string | null | undefined;
	emailHref: string;
	trackEmailDmClick: (id: string) => void;
};

export function EmailDm({ id, email, emailHref, trackEmailDmClick }: Props): React.JSX.Element | null {
	return email ? (
		<div className="ml-auto flex flex-row items-center">
			<Button
				as="a"
				data-testid="email-dm"
				data-qa="email-dm"
				onClick={() => trackEmailDmClick(id)}
				href={emailHref}
				target="_blank"
				variant="secondary"
				size="x-small"
			>
				Send email
			</Button>
		</div>
	) : null;
}
